<template>
    <div>
        <headerV2></headerV2>
    </div>
</template>

<script>
import headerV2 from '../components/header-v2.vue'
export default {
    components: {
        headerV2
    },
    data() {
        return {
            
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/test-index.vue